export default __webpack_public_path__ + "static/media/ey.7554953e.png";